var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedHooper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 33,
    viewBox: "0 0 90 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v9103s6w7a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.683.415H27.01v1.522h5.673V.415z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.683.415H27.01v1.522h5.673V.415z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.175.18h-6.66v.563h6.66V.18zM33.175 1.846h-6.66v.562h6.66v-.562z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.647 2.22h-7.6v.632h7.6V2.22z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.564.745h.189v1.1h-.19v.377h-.18v.632h-2.337v-.632h.467v-.377h.493v-1.1h-.493V.18h2.05v.564zM33.645 2.222v.632h-2.339v-.632h-.181v-.377h-.19v-1.1h.19V.18h2.05v.564h-.492v1.1h.492v.377h.47z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.142.415h-5.673v1.522h5.673V.415z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.142.415h-5.673v1.522h5.673V.415z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.635.18h-6.66v.563h6.66V.18zM45.635 1.846h-6.66v.562h6.66v-.562z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.106 2.22h-7.6v.632h7.6V2.22z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.022.745h.19v1.1h-.19v.377h-.18v.632h-2.335v-.632h.467v-.377h.493v-1.1h-.493V.18h2.048v.564zM46.105 2.222v.632h-2.339v-.632h-.181v-.377h-.19v-1.1h.19V.18h2.05v.564h-.492v1.1h.492v.377h.47z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.602.415h-5.673v1.522h5.673V.415z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.602.415h-5.673v1.522h5.673V.415z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.094.18h-6.66v.563h6.66V.18zM58.094 1.846h-6.66v.562h6.66v-.562z",
    fill: "#757575"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.566 2.22h-7.6v.632h7.6V2.22z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.482.745h.19v1.1h-.19v.377h-.18v.632h-2.335v-.632h.467v-.377h.493v-1.1h-.493V.18h2.048v.564zM58.564 2.222v.632h-2.339v-.632h-.181v-.377h-.19v-1.1h.19V.18h2.05v.564h-.492v1.1h.492v.377h.47z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 22.942h.476v-6.017h-.476v6.017zM9.447 22.942h.476v-6.017h-.476v6.017z",
    fill: "gray"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.755 17.377h3.307v-.452h-3.17l-.137.452z",
    fill: "gray"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m5.95 23.296.456.126 1.844-6.045.137-.452h-.495l-.137.452-1.806 5.919zM73.244 24.617v-9.589h-.772v9.59h.772z",
    fill: "gray"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.324 26.442v-6.704h-3.191v6.704h3.191zM82.485 24.615v-9.59h-.772v9.59h.772z",
    fill: "gray"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.483 14.716h-18.56v.734h18.56v-.734z",
    fill: "gray"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.627 27.586H25.292v.41h11.335v-.41zM61.957 27.586H50.62v.41h11.336v-.41z",
    fill: "#666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 27.89v-1.596h-.432v1.597h.431zM55.831 27.89v-1.596H55.4v1.597h.431zM31.954 27.89v-1.596h-.431v1.597h.431zM34.596 27.89v-1.596h-.432v1.597h.432z",
    fill: "#666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.264 26.41H35.446v.25h12.818v-.25zM48.264 27.959H35.446v.25h12.818v-.25zM70.951 19.464H60.094v.274H70.95v-.274zM64.072 20.647h-9.365v.274h9.365v-.274zM64.072 21.722h-9.365v.274h9.365v-.274z",
    fill: "gray"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.036 18.37H70.42c-.2 0-.362.154-.362.344v2.047c0 .19.162.344.362.344h4.616c.2 0 .362-.154.362-.344v-2.047a.353.353 0 0 0-.362-.344z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.4 18.714v.464h-5.342v-.464a.33.33 0 0 1 .106-.244.365.365 0 0 1 .256-.1h4.616c.096 0 .189.036.257.1a.338.338 0 0 1 .107.244z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4 20.299v.462c0 .091-.039.18-.107.244a.374.374 0 0 1-.257.1H70.42a.372.372 0 0 1-.256-.1.336.336 0 0 1-.106-.244V20.3H75.4z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.893 24.693H23.614v2.355h13.279v-2.355zM60.94 24.693H47.663v2.355h13.279v-2.355z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.832 25.261c.906.209 1.788.5 2.635.87a5.41 5.41 0 0 1 2.13 1.724l-.174.114a5.132 5.132 0 0 0-.907-.959 5.738 5.738 0 0 0-1.14-.706 13.496 13.496 0 0 0-2.597-.855l.053-.188z",
    fill: "#4D4D4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m90 28.265-.087-.118-.11.073.086.118.11-.073zM89.793 28.401l-.087-.118-.11.073.086.118.11-.073z",
    fill: "#CCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m89.73 27.769.274.374-.43.285-.275-.375a.13.13 0 0 1-.023-.102.136.136 0 0 1 .059-.087l.197-.13a.15.15 0 0 1 .107-.023c.037.007.07.027.092.056l-.001.002zM6.044 25.261c-.906.21-1.788.5-2.635.87a5.41 5.41 0 0 0-2.13 1.724l.176.114a5 5 0 0 1 .907-.959c.349-.277.73-.514 1.137-.706a13.487 13.487 0 0 1 2.606-.855l-.06-.188z",
    fill: "#4D4D4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m.992 28.34.086-.117-.11-.073-.087.118.11.073zM1.194 28.474l.086-.118-.11-.073-.087.118.11.073z",
    fill: "#CCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m1.59 28.054-.275.375-.43-.285.274-.374a.144.144 0 0 1 .092-.056.15.15 0 0 1 .107.022l.197.13a.13.13 0 0 1 .036.19l-.002-.002z",
    fill: "#4D4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.007 25.914h1.947a.45.45 0 0 0 .461-.439v-1.37a.45.45 0 0 0-.461-.439h-1.947a.45.45 0 0 0-.461.439v1.37a.45.45 0 0 0 .46.439z",
    fill: "#333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.564 23.975a.482.482 0 0 1 .135-.018h1.947c.123 0 .24.046.327.128a.43.43 0 0 1 .136.31v1.37a.51.51 0 0 1-.018.129.463.463 0 0 0 .233-.16.426.426 0 0 0 .09-.259v-1.372a.418.418 0 0 0-.135-.31.46.46 0 0 0-.325-.127h-1.947a.477.477 0 0 0-.275.085.44.44 0 0 0-.168.224z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m84.72 25.121 3.861.216a.36.36 0 0 0 .254-.088.325.325 0 0 0 .108-.236v-.544a.314.314 0 0 0-.107-.238.347.347 0 0 0-.255-.088l-3.86.216v.762z",
    fill: "#4D4D4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m87.756 24.659.762-.006v-.328l-.762.03v.304zM86.843 24.665l.625-.004v-.294l-.625.024v.274zM86.083 24.673l.522-.006v-.266l-.522.02v.252zM85.442 24.677l.442-.004v-.244l-.442.016v.232zM87.756 25.125l.762.03v-.326l-.762-.006v.302zM86.843 25.09l.625.023v-.294l-.625-.004v.274zM86.083 25.06l.522.021v-.268l-.522-.004v.25zM85.442 25.035l.442.018v-.246l-.442-.004v.232zM88.805 26.126h-.247a.216.216 0 0 1-.149-.059.195.195 0 0 1-.061-.141v-.148h.675v.148a.19.19 0 0 1-.064.144.21.21 0 0 1-.154.056zM87.704 26.126h-.246a.216.216 0 0 1-.15-.059.195.195 0 0 1-.06-.141v-.148h.675v.148a.192.192 0 0 1-.065.144.212.212 0 0 1-.154.056zM.975 25.681l-.83-.364a.249.249 0 0 1-.105-.088.232.232 0 0 1-.04-.128v-.622c0-.046.013-.09.04-.13a.25.25 0 0 1 .105-.088l.83-.363v1.783z",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M.975 23.898v.114l-.695.305a.28.28 0 0 0-.12.099.26.26 0 0 0-.044.145v.7a.283.283 0 0 0 0 .042.241.241 0 0 1-.087-.085.227.227 0 0 1-.033-.115v-.624c0-.046.014-.09.04-.128a.249.249 0 0 1 .105-.088l.834-.365z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.486 24.007v1.566c0 .09-.038.177-.105.241a.367.367 0 0 1-.253.1H1.12a.377.377 0 0 1-.242-.09.334.334 0 0 1-.116-.25v-1.567c0-.09.037-.177.105-.24a.367.367 0 0 1 .253-.1h1.008c.08 0 .158.025.221.072a.337.337 0 0 1 .137.268z",
    fill: "#333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.476 23.927H1.213c-.183 0-.33.236-.33.524v1.373a.334.334 0 0 1-.116-.25v-1.567c0-.09.037-.177.104-.24a.367.367 0 0 1 .253-.1h1.009c.08 0 .156.026.219.073a.336.336 0 0 1 .124.187z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m5.389 25.121-3.86.216a.36.36 0 0 1-.255-.088.326.326 0 0 1-.108-.236v-.544a.313.313 0 0 1 .107-.238.347.347 0 0 1 .255-.088l3.86.216v.762z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m2.354 24.659-.764-.006v-.328l.764.03v.304zM3.267 24.665l-.625-.004v-.294l.625.024v.274zM4.025 24.673l-.52-.006v-.266l.52.02v.252zM4.665 24.677l-.44-.004v-.244l.44.016v.232zM2.354 25.125l-.764.03v-.326l.764-.006v.302zM3.267 25.09l-.625.023v-.294l.625-.004v.274zM4.025 25.06l-.52.021v-.268l.52-.004v.25zM4.665 25.035l-.44.018v-.246l.44-.004v.232z",
    fill: "#333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.282 27.048H61.186l-5.439-1.67H83.58l-10.298 1.67z",
    fill: "#666"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.282 27.048H61.186l-5.439-1.67H83.58l-10.298 1.67z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.282 26.716H61.186l-5.439-1.671H83.58l-10.298 1.67z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.01 23.412h-7.55v3.364h7.55v-3.364z",
    fill: "#1A1A1A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.37 27.048H11.272l-5.439-1.67h22.976l-5.44 1.67z",
    fill: "#666"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.37 27.048H11.272l-5.439-1.67h22.976l-5.44 1.67z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.37 26.716H11.272l-5.439-1.671h22.976l-5.44 1.67z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.097 23.412h-7.551v3.364h7.55v-3.364z",
    fill: "#1A1A1A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.01 24.115H3.403v1.302H86.01v-1.302z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.37 24.915v-.298H4.043v.298h81.325z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.982 19.935h-3.116a.294.294 0 0 0-.3.286v2.2c0 .159.134.287.3.287h3.116a.294.294 0 0 0 .3-.286V20.22a.294.294 0 0 0-.3-.286z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.738 20.153h-2.627a.249.249 0 0 0-.255.242v1.855c0 .134.114.242.255.242h2.627c.14 0 .255-.108.255-.242v-1.855a.249.249 0 0 0-.255-.242z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m45.174 21.881-.55.537-.286.28-.743.724-.482.468-.26.256-.575.56-.17.169-5.045 4.926H34.01l-5.044-4.926-.745-.729-.743-.724-.19-.184-.55-.54-.33-.322-.509-.495h19.276z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.872 24.769H34.2c-.475 0-.86.366-.86.817v1.874c0 .451.385.817.86.817h2.67c.475 0 .86-.366.86-.817v-1.875c0-.45-.385-.816-.86-.816z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.689 26.174h-2.305a.324.324 0 0 1-.22-.086.294.294 0 0 1-.092-.208.29.29 0 0 1 .091-.21.32.32 0 0 1 .22-.087h2.306a.324.324 0 0 1 .22.087.293.293 0 0 1 .09.21.287.287 0 0 1-.091.208.318.318 0 0 1-.22.086zM36.689 27.458h-2.305a.322.322 0 0 1-.22-.085.296.296 0 0 1-.092-.209.282.282 0 0 1 .092-.208.312.312 0 0 1 .22-.086h2.305c.082 0 .16.031.219.086.058.055.09.13.09.208a.287.287 0 0 1-.09.208.318.318 0 0 1-.22.086zM58.658 21.881l-.374.364-.461.453h-.002l-.741.724-.745.724-.744.729-5.043 4.926h-3.055l-5.045-4.926-.17-.168-.573-.56-.261-.257-.482-.468-.011-.01-.733-.714-.149-.146-.686-.67h19.275z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.356 24.769h-2.671c-.474 0-.859.366-.859.817v1.874c0 .451.385.817.859.817h2.671c.475 0 .86-.366.86-.817v-1.875c0-.45-.385-.816-.86-.816z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.173 26.174h-2.305a.325.325 0 0 1-.22-.086.294.294 0 0 1-.091-.209.29.29 0 0 1 .094-.203.32.32 0 0 1 .217-.083h2.305a.324.324 0 0 1 .22.087.294.294 0 0 1 .09.21.288.288 0 0 1-.095.201.318.318 0 0 1-.215.083zM50.173 27.458h-2.305a.322.322 0 0 1-.22-.085.296.296 0 0 1-.091-.209.282.282 0 0 1 .091-.208.311.311 0 0 1 .22-.086h2.305c.082 0 .161.031.219.086.058.055.09.13.09.208a.287.287 0 0 1-.09.208.318.318 0 0 1-.219.086z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.659 21.881-.375.364-.46.453h-.003l-.74.724-.746.724-.743.729-5.044 4.926h-3.054l-5.046-4.926-.17-.168-.17.168-5.045 4.926H34.01l-5.044-4.926-.745-.729-.743-.724-.19-.184-.55-.54-.33-.322-.509-.495h2.103l.663.817.588.724.585.724.587.729L34.01 29.3h3.054l3.583-4.426.59-.729.208-.256.834-1.032.835 1.032.209.256.59.729 3.582 4.426h3.054l3.585-4.426.585-.729.587-.724.588-.724.66-.817h2.106z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.247 5.281v4.779L59.166 21.325l-.882.985-.996 1.112H27.266l-.86-.962-11.098-12.4V5.28l3.816-3.628h46.308l1.27 1.209 1.528 1.453 1.017.966z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.23 4.315H16.322l2.802-2.662h46.308l1.27 1.209 1.528 1.453z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.702 2.862h-48.85l1.272-1.209h46.308l1.27 1.209z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.927 8.055 11.682 15.367h-.343L15.308 10.06V5.284l.619-.588v3.36zM69.247 5.283v4.776L57.29 23.422h-.343L68.63 8.054V4.697l.617.586z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.057 6.984h3.676v2.75h-3.676v-2.75zm0 3.592h3.676v2.361h-3.676v-2.361zm0 3.201h3.676v2.366h-3.676v-2.366zm0 3.202h3.676v2.367h-3.676V16.98zm-4.553-9.995h3.673v2.75h-3.673v-2.75zm0 3.592h3.673v2.361h-3.673v-2.361zm0 3.201h3.673v2.366h-3.673v-2.366zm0 3.202h3.673v2.367h-3.673V16.98zm-4.553-9.995h3.675v2.75h-3.675v-2.75zm0 3.592h3.675v2.361h-3.675v-2.361zm0 3.201h3.675v2.366h-3.675v-2.366zm0 3.202h3.675v2.367h-3.675V16.98zm-4.555-9.995h3.673v2.75h-3.673v-2.75zm0 3.592h3.673v2.361h-3.673v-2.361zm0 3.201h3.673v2.366h-3.673v-2.366zm0 3.202h3.673v2.367h-3.673V16.98zm-4.553-9.995h3.67v2.75h-3.67v-2.75zm0 3.592h3.67v2.361h-3.67v-2.361zm0 3.201h3.67v2.366h-3.67v-2.366zm0 3.202h3.67v2.367h-3.67V16.98zm-4.556-9.995h3.676v2.75h-3.676v-2.75zm0 3.592h3.676v2.361h-3.676v-2.361zm0 3.201h3.676v2.366h-3.676v-2.366zm0 5.573v-2.373h3.676v2.37l-3.676.003zm4.556 4.076v-3.235h3.67v3.24l-3.67-.005zm4.553 0v-3.235h3.673v3.24l-3.673-.005zm4.555 0v-3.235h3.675v3.24l-3.675-.005zm4.553 0v-3.235h3.673v3.24l-3.673-.005zm8.229 0h-3.676v-3.235h3.676v3.235zm.877-16.442h3.674v2.75H54.61v-2.75zm0 3.592h3.674v2.361H54.61v-2.361zm0 3.201h3.674v2.366H54.61v-2.366zm0 5.573v-2.373h3.674v2.37l-3.674.003zM15.308 5.525v1.46h11.1V22.47l.21.236.648.724h.021v-3.24h3.676v3.24h-3.486l.743.725.745.728H42.1l.169-.168.17.168h13.144l.743-.728.745-.725h-2.46v-3.24h3.673v2.128l.882-.985V6.984h10.089V5.525H15.308z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.518 6.252H14.037a.787.787 0 0 1-.54-.214.71.71 0 0 1-.224-.513.71.71 0 0 1 .224-.513.787.787 0 0 1 .54-.213h56.481c.203 0 .397.077.54.213.142.136.222.32.222.513 0 .192-.08.377-.223.513a.785.785 0 0 1-.539.214z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.518 6.252H14.037a.787.787 0 0 1-.54-.214.71.71 0 0 1-.224-.513.71.71 0 0 1 .224-.513.787.787 0 0 1 .54-.213h56.481c.203 0 .397.077.54.213.142.136.222.32.222.513 0 .192-.08.377-.223.513a.785.785 0 0 1-.539.214z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.803 23.664V4.8h-1.526v18.865h1.526z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.803 23.664V4.8h-1.526v18.865h1.526z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.278 23.666V4.801h-1.526v18.865h1.526z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.278 23.666V4.801h-1.526v18.865h1.526z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m16.72 23.144 9.9-16.928-1.335-.705-9.9 16.928 1.335.705z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.72 23.144 9.9-16.928-1.335-.705-9.9 16.928 1.335.705z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m69.176 22.44-9.9-16.929-1.334.705 9.9 16.928 1.334-.705z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m69.176 22.44-9.9-16.929-1.334.705 9.9 16.928 1.334-.705z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.78 23.666V4.801h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.78 23.666V4.801h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.333 23.664V4.8h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.333 23.664V4.8h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.889 23.664V4.8h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.889 23.664V4.8h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.441 23.666V4.801h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.441 23.666V4.801h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.995 23.664V4.8h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.995 23.664V4.8h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.55 23.666V4.801h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.55 23.666V4.801h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.103 23.664V4.8h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.103 23.664V4.8h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.656 23.664V4.8h-.88v18.865h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 23.664V4.8h-.88v18.865h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 9.843h31.879v-.836H26.338v.836z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.338 9.843h31.879v-.836H26.338v.836z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 13.05h31.879v-.837H26.338v.836z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.338 13.05h31.879v-.837H26.338v.836z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 16.253h31.879v-.837H26.338v.837z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.338 16.253h31.879v-.837H26.338v.837z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.338 19.459h31.879v-.837H26.338v.837z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.338 19.459h31.879v-.837H26.338v.837z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M84.22 24.148H5.195c0-.384.161-.753.447-1.025a1.567 1.567 0 0 1 1.08-.425h75.972c.404 0 .793.153 1.079.425.286.272.447.64.447 1.025z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.22 24.148H5.195c0-.384.161-.753.447-1.025a1.567 1.567 0 0 1 1.08-.425h75.972c.404 0 .793.153 1.079.425.286.272.447.64.447 1.025z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22 24.127h-.07c-.1-.294-.294-.55-.556-.732a1.594 1.594 0 0 0-.902-.281H6.722c-.325 0-.64.099-.903.28a1.465 1.465 0 0 0-.556.733h-.072c.001-.385.162-.754.449-1.026a1.57 1.57 0 0 1 1.08-.425h75.97c.2 0 .4.036.585.11.186.072.354.178.497.313.142.135.254.295.331.471.077.177.117.366.117.556z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.718 25.525h-.365v2.45h.365v-2.45z",
    fill: "#C1272D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M36.823 26.922v-.346h-2.576v.346h2.576z",
    fill: "#C1272D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.537 28.273c-.317 0-.627-.089-.89-.256a1.542 1.542 0 0 1-.592-.683 1.453 1.453 0 0 1-.092-.88 1.5 1.5 0 0 1 .438-.78c.224-.213.51-.359.82-.418.311-.058.633-.028.926.087.293.115.543.31.72.56.175.251.27.546.27.847-.001.403-.17.79-.47 1.075-.3.286-.706.447-1.13.448zm0-2.7c-.245 0-.484.07-.688.198-.204.13-.362.314-.456.528a1.123 1.123 0 0 0-.07.68c.047.229.165.438.338.603.173.164.394.276.634.322.24.045.49.022.715-.067.227-.09.42-.24.556-.433.136-.194.208-.421.208-.654 0-.312-.13-.611-.362-.832a1.272 1.272 0 0 0-.875-.345z",
    fill: "#C1272D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35.984 26.75a.411.411 0 0 1-.076.237.444.444 0 0 1-.202.157.47.47 0 0 1-.489-.093.406.406 0 0 1-.096-.465.431.431 0 0 1 .167-.191.465.465 0 0 1 .566.054.423.423 0 0 1 .13.3zM49.203 25.525h-.364v2.45h.364v-2.45z",
    fill: "#C1272D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.308 26.922v-.346H47.73v.346h2.577z",
    fill: "#C1272D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M49.02 28.273c-.317 0-.627-.09-.89-.257a1.542 1.542 0 0 1-.59-.683 1.453 1.453 0 0 1-.091-.88c.062-.296.214-.567.438-.78.224-.213.51-.358.82-.417a1.68 1.68 0 0 1 .926.087c.293.115.543.31.719.56.176.251.27.546.27.847a1.49 1.49 0 0 1-.47 1.075 1.65 1.65 0 0 1-1.132.448zm0-2.7c-.245 0-.484.07-.688.198-.203.13-.362.314-.456.529a1.123 1.123 0 0 0-.07.68c.048.228.166.437.339.602.173.164.393.276.633.322.24.045.49.022.716-.067.226-.09.419-.24.555-.433.136-.194.209-.421.209-.654 0-.312-.13-.611-.363-.832a1.271 1.271 0 0 0-.875-.345z",
    fill: "#C1272D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.468 26.75a.412.412 0 0 1-.076.237.444.444 0 0 1-.2.157.47.47 0 0 1-.49-.093.407.407 0 0 1-.097-.465.432.432 0 0 1 .166-.19.464.464 0 0 1 .566.052.424.424 0 0 1 .131.302z",
    fill: "#C1272D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M78.593 25.113h-.381v4.396h.38v-4.396z",
    fill: "#333"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M82.424 29.147h-4.212v.362h4.212v-.362zM82.426 27.453v-.363H78.21v.363h4.215z",
    fill: "#333"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M82.424 25.113h-.381v4.396h.381v-4.396zM62.546 20.49H62.3v1.664h.246V20.49z",
    fill: "#333"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.298 21.437v-.234h-1.75v.234h1.75z",
    fill: "#333"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.424 22.356a1.13 1.13 0 0 1-.605-.174 1.048 1.048 0 0 1-.402-.464.988.988 0 0 1-.062-.598c.041-.2.145-.385.297-.53.152-.145.346-.243.557-.283.211-.04.43-.02.63.058.198.078.368.211.488.381s.184.37.184.575c-.001.274-.116.537-.319.73a1.12 1.12 0 0 1-.768.305zm0-1.833a.874.874 0 0 0-.467.135.81.81 0 0 0-.31.359.763.763 0 0 0-.048.462.788.788 0 0 0 .23.41.857.857 0 0 0 .431.22c.163.03.333.014.487-.046a.834.834 0 0 0 .377-.295.773.773 0 0 0-.104-1.01.865.865 0 0 0-.596-.235z",
    fill: "#333"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62.73 21.321a.278.278 0 0 1-.052.16.3.3 0 0 1-.136.107.318.318 0 0 1-.33-.063.275.275 0 0 1-.066-.314.291.291 0 0 1 .112-.13.314.314 0 0 1 .449.13.274.274 0 0 1 .022.11zM8.943 23.092h-1.83v1.363h1.83v-1.363z",
    fill: "#333"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24 22.338h-.427v2.873h.428v-2.873z",
    fill: "#C1272D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.538 23.977v-.407H6.515v.407h3.023z",
    fill: "#C1272D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.028 25.56a1.95 1.95 0 0 1-1.045-.301 1.81 1.81 0 0 1-.693-.802 1.705 1.705 0 0 1-.107-1.033c.072-.347.251-.665.514-.915s.598-.42.963-.49a1.97 1.97 0 0 1 1.087.103c.343.135.637.365.843.659.207.294.316.64.316.993-.001.473-.2.927-.551 1.261a1.932 1.932 0 0 1-1.327.524zm0-3.166c-.287 0-.568.08-.807.232a1.399 1.399 0 0 0-.535.62c-.11.252-.138.53-.082.798.056.267.194.513.397.706.203.194.462.325.744.378.282.054.574.026.84-.078.265-.105.491-.282.651-.509a1.333 1.333 0 0 0-.18-1.744 1.46 1.46 0 0 0-.471-.3 1.518 1.518 0 0 0-.557-.105v.002z",
    fill: "#C1272D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M8.029 24.273c.29 0 .524-.223.524-.498a.512.512 0 0 0-.524-.499.512.512 0 0 0-.524.499c0 .275.235.498.524.498z",
    fill: "#C1272D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M13.293 29.021c.255-1.51-.814-2.935-2.39-3.18-1.575-.246-3.06.78-3.315 2.292-.256 1.511.814 2.936 2.39 3.18 1.575.246 3.059-.78 3.315-2.291z",
    fill: "gray"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.441 31.131c1.47 0 2.663-1.143 2.663-2.554 0-1.411-1.192-2.555-2.663-2.555-1.47 0-2.663 1.144-2.663 2.555 0 1.41 1.192 2.554 2.663 2.554z",
    fill: "#4D4D4D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.44 30.356c1.025 0 1.856-.797 1.856-1.78 0-.982-.83-1.78-1.855-1.78s-1.855.798-1.855 1.78c0 .983.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.022 28.577a.57.57 0 0 1-.58.557.568.568 0 0 1-.582-.557c0-.309.26-.558.581-.558.322 0 .58.25.58.558z",
    fill: "#4D4D4D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.148 29.022c.256-1.51-.814-2.935-2.39-3.18-1.575-.246-3.059.78-3.314 2.292-.256 1.511.814 2.936 2.389 3.18 1.575.246 3.06-.78 3.315-2.292z",
    fill: "gray"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21.296 31.131c1.47 0 2.662-1.143 2.662-2.554 0-1.411-1.192-2.555-2.662-2.555-1.471 0-2.663 1.144-2.663 2.555 0 1.41 1.192 2.554 2.663 2.554z",
    fill: "#4D4D4D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.296 30.357c1.025 0 1.855-.797 1.855-1.78s-.83-1.78-1.855-1.78c-1.024 0-1.855.797-1.855 1.78s.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M21.876 28.577a.57.57 0 0 1-.58.557.568.568 0 0 1-.581-.557c0-.309.259-.558.58-.558.322 0 .581.25.581.558zM15.778 28.026h-1.762v.257h1.762v-.257zM15.778 28.489h-1.762v.257h1.762v-.257zM15.778 27.565h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m15.778 27.822-1.762.477v-.257l1.762-.477v.257z",
    fill: "gray"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15.778 28.95h-1.762v.257h1.762v-.257zM15.778 29.421h-1.762v.258h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m15.778 28.285-1.762.475v-.258l1.762-.476v.259zM15.778 28.746l-1.762.477v-.258l1.762-.476v.257zM15.778 29.21l-1.762.474v-.257l1.762-.477v.26z",
    fill: "gray"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M15.778 27.104h-1.762v.257h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m15.778 27.36-1.762.476v-.258l1.762-.474v.257z",
    fill: "gray"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17.718 28.026h-1.762v.257h1.762v-.257zM17.718 28.489h-1.762v.257h1.762v-.257zM17.718 27.565h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m17.718 27.822-1.762.477v-.257l1.762-.477v.257z",
    fill: "gray"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17.718 28.95h-1.762v.257h1.762v-.257zM17.718 29.421h-1.762v.258h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m17.718 28.285-1.762.475v-.258l1.762-.476v.259zM17.718 28.746l-1.762.477v-.258l1.762-.476v.257zM17.718 29.21l-1.762.474v-.257l1.762-.477v.26z",
    fill: "gray"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17.718 27.104h-1.762v.257h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m17.718 27.36-1.762.476v-.258l1.762-.474v.257z",
    fill: "gray"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22.598 27.112a.913.913 0 0 0-.627-.315l-3.907-.285h-4.393l-3.906.285a.906.906 0 0 0-.627.315.829.829 0 0 0-.156.811l.286.83h2.847l1.09 1.178a.874.874 0 0 0 .64.276h4.047a.874.874 0 0 0 .64-.276l1.09-1.178h2.847l.286-.83a.828.828 0 0 0-.155-.81h-.002zm-9.466 1.204c0 .165-.197.259-.335.16l-1.015-.736v-.434c0-.093.08-.168.176-.168h.999c.096 0 .175.075.175.168v1.01zm4.718.919c0 .192-.163.35-.365.35h-3.236a.358.358 0 0 1-.365-.35v-1.747c0-.192.163-.35.365-.35h3.236c.2 0 .365.156.365.35v1.747zm2.101-1.495-1.015.735c-.137.1-.334.005-.334-.16v-1.009c0-.093.078-.168.175-.168h.999c.096 0 .175.075.175.168v.434z",
    fill: "gray"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M10.905 27.95h-.931a.184.184 0 0 0-.188.18v.894c0 .1.084.18.188.18h.93c.104 0 .188-.08.188-.18v-.893c0-.1-.084-.18-.187-.18zM21.761 27.95h-.93a.184.184 0 0 0-.188.18v.894c0 .1.084.18.187.18h.931c.104 0 .188-.08.188-.18v-.893c0-.1-.084-.18-.188-.18z",
    fill: "#4D4D4D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M66.293 29.021c.255-1.51-.814-2.935-2.39-3.18-1.575-.246-3.06.78-3.315 2.292-.256 1.511.814 2.936 2.39 3.18 1.575.246 3.059-.78 3.315-2.291z",
    fill: "gray"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.441 31.131c1.47 0 2.663-1.143 2.663-2.554 0-1.411-1.192-2.555-2.663-2.555-1.47 0-2.663 1.144-2.663 2.555 0 1.41 1.193 2.554 2.663 2.554z",
    fill: "#4D4D4D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M63.44 30.356c1.025 0 1.856-.797 1.856-1.78 0-.982-.83-1.78-1.855-1.78s-1.855.798-1.855 1.78c0 .983.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M64.022 28.577a.57.57 0 0 1-.58.557.568.568 0 0 1-.582-.557c0-.309.26-.558.581-.558.322 0 .58.25.58.558z",
    fill: "#4D4D4D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M77.148 29.022c.256-1.51-.814-2.935-2.39-3.18-1.575-.246-3.059.78-3.314 2.292-.256 1.511.813 2.936 2.389 3.18 1.575.246 3.06-.78 3.315-2.292z",
    fill: "gray"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.296 31.131c1.47 0 2.662-1.143 2.662-2.554 0-1.411-1.192-2.555-2.662-2.555-1.471 0-2.663 1.144-2.663 2.555 0 1.41 1.192 2.554 2.663 2.554z",
    fill: "#4D4D4D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M74.296 30.357c1.025 0 1.855-.797 1.855-1.78s-.83-1.78-1.855-1.78c-1.024 0-1.855.797-1.855 1.78s.83 1.78 1.855 1.78z",
    fill: "#333"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M74.876 28.577a.57.57 0 0 1-.58.557.568.568 0 0 1-.581-.557c0-.309.259-.558.58-.558.322 0 .581.25.581.558zM68.778 28.026h-1.762v.257h1.762v-.257zM68.778 28.489h-1.762v.257h1.762v-.257zM68.778 27.565h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m68.778 27.822-1.762.477v-.257l1.762-.477v.257z",
    fill: "gray"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M68.778 28.95h-1.762v.257h1.762v-.257zM68.778 29.421h-1.762v.258h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m68.778 28.285-1.762.475v-.258l1.762-.476v.259zM68.778 28.746l-1.762.477v-.258l1.762-.476v.257zM68.778 29.21l-1.762.474v-.257l1.762-.477v.26z",
    fill: "gray"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M68.778 27.104h-1.762v.257h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m68.778 27.36-1.762.476v-.258l1.762-.474v.257z",
    fill: "gray"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M70.718 28.026h-1.762v.257h1.762v-.257zM70.718 28.489h-1.762v.257h1.762v-.257zM70.718 27.565h-1.762v.257h1.762v-.257z",
    fill: "#4D4D4D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m70.718 27.822-1.762.477v-.257l1.762-.477v.257z",
    fill: "gray"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M70.718 28.95h-1.762v.257h1.762v-.257zM70.718 29.421h-1.762v.258h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m70.718 28.285-1.762.475v-.258l1.762-.476v.259zM70.718 28.746l-1.762.477v-.258l1.762-.476v.257zM70.718 29.21l-1.762.474v-.257l1.762-.477v.26z",
    fill: "gray"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70.718 27.104h-1.762v.257h1.762v-.258z",
    fill: "#4D4D4D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m70.718 27.36-1.762.476v-.258l1.762-.474v.257z",
    fill: "gray"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M75.598 27.112a.913.913 0 0 0-.627-.315l-3.907-.285h-4.393l-3.906.285a.906.906 0 0 0-.627.315.829.829 0 0 0-.156.811l.286.83h2.847l1.09 1.178a.874.874 0 0 0 .64.276h4.047a.874.874 0 0 0 .64-.276l1.09-1.178h2.847l.286-.83a.828.828 0 0 0-.155-.81h-.002zm-9.466 1.204c0 .165-.197.259-.335.16l-1.015-.736v-.434c0-.093.08-.168.176-.168h.999c.096 0 .175.075.175.168v1.01zm4.718.919c0 .192-.163.35-.365.35h-3.236a.358.358 0 0 1-.365-.35v-1.747c0-.192.163-.35.365-.35h3.236c.2 0 .365.156.365.35v1.747zm2.101-1.495-1.015.735c-.138.1-.334.005-.334-.16v-1.009c0-.093.078-.168.175-.168h.999c.097 0 .175.075.175.168v.434z",
    fill: "gray"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M63.905 27.95h-.931a.184.184 0 0 0-.188.18v.894c0 .1.084.18.188.18h.93c.104 0 .188-.08.188-.18v-.893c0-.1-.084-.18-.187-.18zM74.761 27.95h-.93a.184.184 0 0 0-.188.18v.894c0 .1.084.18.187.18h.931c.104 0 .188-.08.188-.18v-.893c0-.1-.084-.18-.188-.18z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "v9103s6w7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .18)",
    d: "M0 0h90v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedHooper);
export default __webpack_public_path__ + "static/media/closed_hooper.ec91ac6499ba1ae93d15d46e0edea178.svg";
export { ForwardRef as ReactComponent };